import React from 'react'
import { Link } from 'gatsby';

const Blog = () => {
  return ( 
  <div className="mx-auto max-w-7xl pt-32 pb-52 sm:px-6 lg:px-8">
    <div className="relative isolate overflow-hidden bg-gray-900 px-6 pt-16 shadow-2xl sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0">
    <div className="mx-auto max-w-md text-left md:text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-left">
      <span className="rounded-full bg-brand-500/10 px-3 py-1 text-sm/6 font-semibold text-brand-400 ring-1 ring-inset ring-brand-500/20">Blog</span>
      <h2 className="text-balance text-3xl font-semibold tracking-tight text-white sm:text-4xl mt-8 md:text-center lg:text-left">Why you need a status page</h2>
      <p className="mt-6 text-pretty text-lg/8 text-gray-300 md:text-center lg:text-left">The stakes for customer trust and satisfaction have never been higher. In our always-on, hyper-connected digital world, downtime, disruptions, or service glitches aren't just technical issues; they're moments that can shatter customer trust...</p>
      <div className="mt-10 flex items-center justify-start md:justify-center lg:justify-start">
        <Link to="/blog/why-you-need-a-status-page/" className="text-sm/6 font-semibold text-white">Continue reading on our blog <span aria-hidden="true">→</span></Link>
      </div>
    </div>
      <div className="relative mt-16 h-80 lg:mt-8">
      <img 
      className="absolute left-0 top-0 w-full max-w-[57rem] md:w-[57rem] rounded-md bg-white/5 ring-1 ring-white/10"
      src="/images/homepage/blog_why.webp" 
      alt="Blog image" />
      </div>
    </div>
  </div>
   );
}
 
export default Blog;